import React, { FC } from 'react';
import styles from './MiniBanner.module.scss';

interface OwnProps {
  referenceUrl: string;
  imageUrl: string;
  bannerAltText: string;
}

const MiniBanner: FC<OwnProps> = ({ bannerAltText, imageUrl, referenceUrl }) => {
  return (
    <div className={styles.miniBanner}>
      {referenceUrl && (
        <a href={referenceUrl} className={styles.link}>
          <img src={imageUrl} alt={bannerAltText} className={styles.image} />
        </a>
      )}
      <br />
      <br />
    </div>
  );
};

export default MiniBanner;
